var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconarrowupblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99955 9.35473L14.1244 13.4795L15.3029 12.301L9.99955 6.99764L4.69629 12.301L5.8748 13.4795L9.99955 9.35473Z",
    fill: "#1271FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconarrowupblue);
export default __webpack_public_path__ + "static/media/icon.arrow.up.blue.f986f2ca30b81d93d022fe604d7b6340.svg";
export { ForwardRef as ReactComponent };